import { Edit, Home, Key, Lock, LockOpen, RemoveCircle, Save } from '@mui/icons-material';
import { Alert, Container, FormControl, FormGroup, FormLabel, IconButton, Link, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { IB } from './SettingPanel';
import Service from '../../../../util/Service';
import { formataData } from '../../../../util/Utilitarios';


export default function ChavesPanel() {

    const [open, setOpen] = React.useState(false);
    const [lista, setLista] = React.useState([]);
    
    const [chave, setChave] = React.useState({
        key: '', value: '', descricao: '', privado: true
    });
    const [msg, setMsg] = React.useState({
        severity: 'success',
        txt: ''
    });

    React.useEffect(() => {
        buscaChaves();
    }, [])

    const buscaChaves = () => {
        Service.GET("/api/security/setting/buscaByTipo/securityKey").then(r => {            
            // setLista(r);
            Service.GET("/api/security/setting/buscaByTipo/openKey").then(r2 => {            
                r.push(...r2);
                setLista(r);
            })
        })
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const handleSettingSave = () => {
        console.log(chave);
        Service.POST("/api/security/setting/incluirSecurityKey", chave).then(r => {
            if (r.success) {
                setChave({ key: '', value: '', descricao: '', privado: true})
                setOpen(true);
                setMsg({
                    severity: 'success',
                    txt: 'Salvo com sucess!'
                });
                buscaChaves();
            } else {
                setOpen(true);
                setMsg({
                    severity: 'warning',
                    txt: r.msg
                })
            }
        })
    }
    function handleChange(e) {
        var c = { ...chave };
        c[e.target.name] = e.target.value;
        setChave(c);
    }
    function isDisable() {
        if (!chave) return true;
        if (chave.key.length === 0) return true;
        if (chave.value.length === 0) return true;
        return false;
    }
    function handleRemove(id) {
        console.log(id)
        Service.GET("/api/security/setting/remove/"+id).then( r=>{
            if( r.success){
                setOpen(true);
                setMsg({
                    severity: 'success',
                    txt: 'Salvo com sucess!'
                });
                buscaChaves();
            } else {
                setOpen(true);
                setMsg({
                    severity: 'warning',
                    txt: r.msg
                })
            }
        })
    }
    function handleOpenClose(){
        var c = { ...chave };
        c.privado = !c.privado;
        setChave(c);
    }
    return (
        <Container maxWidth="lg">
            <Stack spacing={2}>
                <div className='pd-nav'>
                    <Link href="/">
                        <IB>
                            <Home />
                        </IB>
                    </Link>
                    <Link href="/setting">Setting</Link>
                    <Link href="#">Chaves</Link>
                </div>
                <Stack direction="row" spacing={2}>
                    <TextField label="Chave" name="key" variant="standard" helperText="Identificação da chave" value={chave.key} onChange={handleChange} />
                    <TextField label="Valor" sx={{ minWidth: '400px' }} name="value" variant="standard" helperText="Valor a ser criptogravado" value={chave.value} onChange={handleChange} />
                    <TextField label="Descrição" multiline maxRows={4} name="descricao" variant="standard" sx={{ minWidth: '400px' }}
                        helperText="Descrição da chave"
                        value={chave.descricao} onChange={handleChange}
                    />
                    <div>
                        <Tooltip title={chave.privado?'Chave protegida':'Chave aberta'}>
                            <IconButton color='primary' onClick={handleOpenClose} >
                                { chave.privado?<Lock />:<LockOpen/> }
                            </IconButton>
                        </Tooltip>
                        <IconButton color='primary' onClick={handleSettingSave} disabled={isDisable()} >
                            <Save />
                        </IconButton>
                    </div>

                </Stack>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    Chave/Valor
                                </TableCell>
                                <TableCell>Proprietário</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Descrição</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lista.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <IconButton size='small' onClickCapture={() => handleRemove(row.id)}>
                                            <RemoveCircle />
                                        </IconButton>
                                        {row.confs.key+": "+ (row.tipo === 'openKey'? row.confs.value:"###") }
                                    </TableCell>
                                    <TableCell>{row.user.nome}</TableCell>
                                    <TableCell>{formataData(row.dtCriacao)}</TableCell>
                                    <TableCell>
                                        <span style={{ fontSize: '0.9rem' }}>{row.confs.descricao}</span>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Stack>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.txt}
                </Alert>
            </Snackbar>
        </Container>
    )
}